export const FETCH_NURSING_NOTES_RECORDS_SUCCESS = 'FETCH_NURSING_NOTES_RECORDS_SUCCESS';
export const FETCH_NURSING_NOTES_RECORDS_START = 'FETCH_NURSING_NOTES_RECORDS_START';
export const FETCH_NURSING_NOTES_RECORDS_END = 'FETCH_NURSING_NOTES_RECORDS_END';
